import { render, staticRenderFns } from "./a_bigorder_ph.vue?vue&type=template&id=4b0306aa&scoped=true"
import script from "./a_bigorder_ph.vue?vue&type=script&lang=js"
export * from "./a_bigorder_ph.vue?vue&type=script&lang=js"
import style0 from "./a_bigorder_ph.vue?vue&type=style&index=0&id=4b0306aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0306aa",
  null
  
)

export default component.exports